module.exports = __webpack_public_path__ + "static/img/smartProduct14.ab55e747.png";